<template>
  <div>
    <common-dialog
      ref="dialog"
      width="600px"
      :show-save-button="!readonly"
      unit="任课信息"
      edit-title
      id-key="TeachersTeachingId"
      :data="data"
      :form-rules="rules"
      :get-data-func="api.info"
      :save-func="api.save"
      :before-save="onBeforeSave"
      @details-opened="onDetailsOpened"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      close-on-saved
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="教师" prop="Teacher">
              <el-input size="mini" v-model="data.Teacher" placeholder="点击选择" readonly @focus="onTeacherDialog" :style="isMB?'width:200px;':''"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="科目" prop="Subject">
              <el-select v-model="data.Subject" size="small" :style="isMB?'width:200px;':''">
                <el-option v-for="item in subList" :key="item.SubjectId" :value="item.Subject"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="学期名称" prop="TermId">
              <!-- <el-input size="mini" v-model="data.TermNumber" placeholder="点击选择" readonly @focus="onTermDialog"></el-input> -->
              <el-select v-model="data.TermId" size="small" :style="isMB?'width:200px;':''">
                <el-option v-for="item in termList" :key="item.TermId" :value="item.TermId" :label="item.TermName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
    <teacher-dialog ref="teacherDialog" in-dialog selectable :multiple="false" @select="setTeacher" />
    <term-dialog ref="termDialog" in-dialog selectable :multiple="false" @select="setTerm" />
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import teacherDialog from "@/components/sys/teacher/listDialog"
import termDialog from "@/components/ed/term/listDialog";
import termApi from "@/api/ed/term";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    teacherDialog,
    termDialog,
  },
  data() {
    return {
      data: {
        TeachersTeachingId: 0,
        TermId: 0,
        TermNumber: "",
        TeacherId: 0,
        Teacher: "",
        Subject: "",
        ClassId: 0
      },
      api: require("@/api/ed/teach").default,
      subApi: require("@/api/ed/subject").default,
      termApi,
      readonly: false,
      subList: [],
      termList: [],
      isMB: this.$store.state.isMB,
      rules: {
        Teacher: [{ required: true, message: "请选择教师" }],
        Subject: [{ required: true, message: "请选择科目" }],
        TermId: [{ required: true, message: "请选择学期" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened(row) {
      this.data.ClassId = Number(sessionStorage.getItem("classId")) || 0
      this.data.TermId = Number(sessionStorage.getItem("termId")) || 0
      console.log(this.data)
      this.getOption()
    },
    onEditOpened(row) {
      console.log(row)
      this.getOption()
    },
    onDetailsOpened(row) {
      this.onEditOpened(row)
    },
    getOption() {
      this.subApi.list({PageSize:100,PageIndex:1}).then(res => {
        this.subList = res.Data || []
      })
      this.termApi.list().then(res => {
        this.termList = res.Data || []
        this.data.TermId = Number(sessionStorage.getItem("termId")) || null
      })
    },
    onBeforeSave() {
    },
    // termChange(id) {
    //   this.termList.forEach(e => {
    //     if(e.TermId == id) {
    //       this.data.TermNumber = e.TermNumber
    //     }
    //   });
    // },
    onTeacherDialog() {
      this.$refs.teacherDialog.open().then((that) => {
        that.getData();
      });
    },
    setTeacher(t) {
      this.data.TeacherId = t.TeacherId
      this.data.Teacher = t.TeacherName
    },
    onTermDialog() {
      this.$refs.termDialog.open().then((that) => {
        that.getData();
      });
    },
    setTerm(t) {
      this.data.TermId = t.TermId
      this.data.TermNumber = t.TermNumber
    },
  },
};
</script>
<style lang="scss">
</style>